export const handleize = (str) => {
  return str.replace(/[\W_]+/g,' ').trim().replaceAll(' ', '-').toLowerCase();
}